<template>
  <div class="item-wrapper" :class="{ expanded: isExpanded }">
    <v-list-item
      style="border-bottom: 1px solid #ededf0"
      two-line
      :class="{
        'list-item': true,
        active: highlight,
      }"
      @click="toggleExpanded"
      :href="href"
    >
      <v-list-item-avatar
        v-if="!!$slots['image']"
        class="item-avatar"
        style="margin-right: 16px; margin-top: 12px; align-self: flex-start"
      >
        <slot name="image">Image</slot>
      </v-list-item-avatar>

      <v-list-item-content class="item-content">
        <v-list-item-title class="item-title">
          <slot name="title" :expanded="isExpanded">Titel</slot>
        </v-list-item-title>

        <v-list-item-subtitle
          v-if="!!$scopedSlots['meta-columns']"
          class="item-columns pb-2"
          style="font-size: 14px"
          @mousedown.stop
          @touchstart.stop
        >
          <slot name="meta-columns" :expanded="isExpanded">Meta Columns</slot>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="!!$slots['actions']">
        <slot name="actions">
          <v-list-item-action-text>Actions</v-list-item-action-text>
        </slot>
      </v-list-item-action>
    </v-list-item>
    <div
      v-if="isExpanded && !!$slots['expanded-content']"
      style="padding: 12px 16px"
    >
      <slot name="expanded-content"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue"
export default Vue.extend({
  props: {
    highlight: { type: Boolean, default: false },
    clickToOpen: { type: Boolean, default: true },
    expanded: { type: Boolean, default: false },
    href: { type: String },
  },
  data: function () {
    return {
      clicked: false,
    }
  },
  methods: {
    toggleExpanded() {
      if (!this.clickToOpen) {
        this.$emit("click")
        return
      }
      this.clicked = !this.clicked
    },
  },
  computed: {
    isExpanded(): boolean {
      if (this.clickToOpen) {
        return this.clicked
      } else {
        return this.expanded
      }
    },
  },
})
</script>

<style>
.item-wrapper {
  * {
    transition-duration: 0s !important;
  }

  &.expanded,
  .list-item.active {
    background: #307ef7;
    color: white !important;

    .item-avatar > * {
      color: white !important;
    }
    .item-title {
      color: white !important;
    }
    .item-columns {
      .theme--light.v-icon {
        color: white !important;
      }
      color: white !important;
    }
    a {
      color: white !important;
    }
  }
}

.item-content {
  display: flex;
  flex-wrap: wrap;
  .item-title {
    white-space: normal;
    flex-grow: 1;
    flex-shrink: 1;
    min-width: 300px;
    align-self: flex-start;
    flex-basis: 30rem;
    margin-bottom: 8px !important;
    a {
      text-decoration: none;
      font-family: system-ui;
      font-weight: 400;
      color: inherit;
      font-size: 1.14285714rem;
      line-height: 1.5rem;
    }
  }
  .item-columns {
    display: flex !important;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-basis: 30rem;
    flex-grow: 2;
    min-width: 0;
    > * {
      flex-wrap: nowrap;
      justify-content: left;
      flex-basis: 10rem;
      align-items: center;
      overflow: hidden;
      white-space: normal;
      flex-grow: 1;
      min-width: 200px;
      padding-top: 4px;
    }
  }
}
</style>
